import React from 'react';
import './IncompleteTabWarning.css';

/**
 * IncompleteTabWarning - Displays a warning for incomplete tabs
 * @param {string} message - Custom warning message (optional)
 */
const IncompleteTabWarning = ({ message = 'This section is incomplete. Please complete all fields before proceeding.' }) => {
  return (
    <div className="incomplete-tab-warning">
      <div className="warning-icon">⚠</div>
      <div className="warning-content">
        <h4>Section Incomplete</h4>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default IncompleteTabWarning;
